export class ENDPOINTS {
    public static BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
    // Items API endpoints
    public static ITEMS = {
        V2: 'Items/v2',
        V2_ALL: 'Items/v2/all',
        V2_ALL_LIGHT: 'Items/v2/allLight',
        GET_AVAILABLE_ITEM_NAMES: 'Items/GetAvailableItemNames',
    };

    public static STOCKS = {
        V2: 'Stocks/v2',
        V2_BY_ITEM: 'Stocks/v2/by-item/',
    };

    // Recipe API endpoints
    public static RECIPES = {
        V2: 'Recipes/v2',
        V2_FOR_ORDER: 'Recipes/v2/forOrder',
        V2_ALL_LIGHT: 'Recipes/v2/allLight',
        V2_PARTS: 'Recipes/v2/parts',
        AVAILABLE_NAMES: 'Recipes/GetAvailableRecipeNames',
        RECIPE_PART_CATEGORIES: 'Recipes/RecipePartCategories',
    };

    // Order API endpoints
    public static ORDERS = {
        V2: 'Orders/v2',
        WORKSHOP_DATES: 'Orders/workshop/dates',
        V2_SEARCH: 'Orders/v2/search',
        V2_HAS_UNREVIEWED: 'Orders/v2/has-unreviewed',
    };

    // Filling API endpoints
    public static FILLINGS = {
        V2: 'Fillings/v2',
        V2_ALL_LIGHT: 'Fillings/v2/allLight',
    };

    // Image API endpoints
    public static IMAGES = {
        V2: 'Images/v2',
    };

    // ProductType API endpoints
    public static PRODUCT_TYPES = {
        V2: 'ProductTypes/v2',
        V2_FOR_ORDER: 'ProductTypes/v2/forOrder',
        V2_ALL_LIGHT: 'ProductTypes/v2/allLight',
    }

    // Package API endpoints
    public static PACKAGES = {
        AVAILABLE_NAMES: 'Packages/GetAvailablePackageNames',
        V2: 'Packages/v2',
        V2_FOR_ORDER: 'Packages/v2/forOrder',
    }

    // Decoration API endpoints
    public static DECORATIONS = {
        V2: 'Decorations/v2',
        V2_ALL_LIGHT: 'Decorations/v2/allLight',
    }

    public static CALENDAR = {
        HOLIDAYS: 'Calendar/holidays',
    };

    public static ANALYTICS = {
        ORDERS: 'Analytics/orders',
    };

    public static FINANCES = {
        SUMMARY: 'Finances/Summary',
        TRANSACTIONS: 'Finances/Transactions',
        EXPENSE_CATEGORIES: 'Finances/ExpenseCategories',
        EXPENSES: 'Finances/Expenses',
    };
}

// Auth API endpoints
export const LOG_IN = 'Auth/SignIn';
export const LOG_OUT = 'Auth/SignOut';

// User API endpoints
export const GET_USER_DATA = 'Users/GetUserData';
export const SAVE_USER = 'Users/SaveUser';
export const UPDATE_USER = 'Users/UpdateUser';
export const CUSTOMERS_V2 = 'Customers/v2';
